import { render } from "./StepMessages.vue?vue&type=template&id=495bc23e&scoped=true"
import script from "./StepMessages.vue?vue&type=script&lang=js"
export * from "./StepMessages.vue?vue&type=script&lang=js"

import "./StepMessages.vue?vue&type=style&index=0&id=495bc23e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495bc23e"]])

export default __exports__